import { css } from 'emotion';
import { lightGrey, mobileMaxWidthBreakpoint } from 'inside-out/global-styles';
import OffIcon from 'inside-out/images/drop-down-grey-icon.svg';

export const componentWrapStyle = css({
	position: 'relative',
});

const height = 46;

export const componentInnerStyle = active => css({
	width: '100%',
	height: height,
	padding: '0 15px',
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	borderRadius: '4px',
	border: `1px solid ${lightGrey}`,
	background: '#f4f4f4',
	cursor: 'pointer',
	outline: 'none',

	'&:after': {
		content: "''",
		display: 'block',
		width: '14px',
		height: '9px',
		position: 'absolute',
		top: '50%',
		right: '15px',
		transform: `translateY(-50%)${active ? ' scaleY(-1)' : ''}`,
		background: `url(${OffIcon}) no-repeat center`,
	},

	'& > span': {
		marginLeft: '20px',
		fontSize: '14px',
		color: '#000',
		fontWeight: 500,
	}
});

export const componentDropDownStyle = css({
	position: 'absolute',
	top: height + 10,
	zIndex: 10,

	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		width: '100%',
	}
});

export const backdropStyle = css({
	position: 'fixed',
	top: 0,
	right: 0,
	bottom: 0,
	left: 0,
	zIndex: 9,
})



// WEBPACK FOOTER //
// ./src/components/resource-library/audienceDropDown/styles.js